module.exports = __webpack_public_path__ + "img/62.ac904706.png";